import Vue from 'vue';
import vuex from 'vuex';

Vue.use(vuex);

import * as actions from './actions'
import mutations from './mutations'

export default new vuex.Store({
  state: {
    notifications: null,
    fetchingNotifications: false,
    initialized: false,
    authUser: null,
    notAllowedMessage: null,
    fetchingUsers: false,
    users: null,
    selectedUser: null,
    fetchingDashboardData: false,
    dashboardData: null,
    fetchingDashboardLoans: false,
    dashboardLoans: null,
    dashboardSummaries: [
      { id: 'clients', title: 'Clients', count: undefined, amount: undefined, visible: false },
      { id: 'savings', title: 'Savings Accounts', count: undefined, amount: undefined, visible: false },
      { id: 'loans', title: 'Loan Accounts', count: undefined,  amount: undefined, visible: false },
      { id: 'bank', title: 'Bank Account Balance', count: undefined, amount: undefined, visible: false }
    ],
    savingsData: null,
    savingsPagination: null,
    fetchingSavingsData: false,
    staffUsers: null,
    fetchingStaffUsers: false,
    creatingStaffUser: false,
    createStaffUserError: null,
    staffUserBeingEdited: null,
    roles: null,
    fetchingRoles: false,
    creatingRole: false,
    createRoleError: null,
    roleBeingEdited: null,
    roleBeingDeleted: null,
    deletingRole: false,
    fetchingStaffUsersForRole: false,
    permissions: null,
    fetchingPermissions: false,
    
    fetchingFinlinkAccounts: false,
    finlinkAccounts: null,
    selectedFinlinkAccountId: null,
    fetchingFinlinkAccountTransactions: false,
    finlinkAccountTransactions: null,
    finlinkAccountTransactionsPagination: null,
    
    transactionLogs: null,
    transactionLogsPagination: null,
    fetchingTransactionLogs: false,
    transactions: null,
    transactionTypeFilter: "All",
    transactionsPagination: null,
    fetchingTransactions: false,
    creatingTransaction: false,
    bankBalances: null,
    bankBalancesPagination: null,
    fetchingBankBalances: false,
    creatingBankBalance: false,
    reconStatement: null,
    fetchingReconStatement: false,
    bankTransactions: null,
    fetchingBankTransactions: false,
    creatingBankTransaction: false,
    accounts: null,
    fetchingAccounts: false,
    auditTrail: null,
    auditTrailMetadata: null,
    fetchingAuditTrail: false,
    fetchingConfigs: false,
    configs: null,
    configBeingEdited: null,
    savingConfig: false,
    fetchingSupportedBanks: false,
    supportedBanks: null,
    supportedBanksPagination: null,
    supportedBankBeingEdited: null,
    savingSupportedBank: false,
    fetchingLoanApplications: false,
    loanApplications: null,
    loanApplicationsPagination: null,
    loanApplicationBeingEdited: null,
    savingLoanApplication: false,

    reminders: null,
    fetchingReminders: false,
    creatingReminder: false,
    reminderBeingEditedId: null
  },
  actions,
  mutations,
  getters: {
    currentLoanApplication: state => {
      if(!state.loanApplicationBeingEdited || !state.loanApplications)
        return null;

      return state.loanApplications.find(({_id}) => _id === state.loanApplicationBeingEdited)
    },
    selectedFinlinkAccount: state => {
      if(!state.selectedFinlinkAccountId || !state.finlinkAccounts)
        return null;

      return state.finlinkAccounts.find(({_id}) => _id === state.selectedFinlinkAccountId)
    },
    reminderBeingEdited: state => {
      if(!state.reminderBeingEditedId || !state.reminders)
        return null;

      return state.reminders.find(({_id}) => _id === state.reminderBeingEditedId)
    }
  }
})
